import { render, staticRenderFns } from "./CharCounter.vue?vue&type=template&id=6a0e8e2e&scoped=true&"
import script from "./CharCounter.vue?vue&type=script&lang=js&"
export * from "./CharCounter.vue?vue&type=script&lang=js&"
import style0 from "./CharCounter.vue?vue&type=style&index=0&id=6a0e8e2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0e8e2e",
  null
  
)

export default component.exports